export default __webpack_public_path__ + "static/media/img5.a65e7762.png";